import { __rest, __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { StyledDivider, ZigMenuItem, ChildContainer, SpaceTaker, ArrowBottomIconStyled } from './styles.js';
import { MenuList, Box } from '@mui/material';
import { useInRouterContext, Link } from 'react-router-dom';

var MenuOption = function (_a) {
    var option = _a.option, index = _a.index, onClick = _a.onClick, expandedOption = _a.expandedOption, setExpandedOption = _a.setExpandedOption;
    var element = option.element; option.children; var label = option.label, href = option.href, optionProps = __rest(option, ["element", "children", "label", "href"]);
    var routerContext = useInRouterContext();
    var renderOption = function () {
        var _a, _b;
        if (element) {
            return (React__default.createElement(ZigMenuItem, __assign({}, optionProps, { id: option.id || "dropdown-element-".concat(index), preserveStyles: (_a = option.preserveStyles) !== null && _a !== void 0 ? _a : false, onClick: option.onClick || href ? onClick(option.onClick) : undefined }), option.element));
        }
        if (href || option.onClick) {
            return (React__default.createElement(ZigMenuItem, __assign({ autoFocus: true }, (href &&
                (routerContext
                    ? {
                        component: Link,
                        to: href,
                    }
                    : { component: "a", href: href })), optionProps, { onClick: onClick(option.onClick) }), label));
        }
        if (option.children) {
            return (React__default.createElement(ChildContainer, { active: expandedOption === option },
                React__default.createElement(ZigMenuItem, { id: option.id, sx: option.sx, onClick: function () { var _a; return ((_a = option.children) === null || _a === void 0 ? void 0 : _a.length) && setExpandedOption(function (v) { return (v ? null : option); }); } },
                    label,
                    React__default.createElement(SpaceTaker, null),
                    !!((_b = option.children) === null || _b === void 0 ? void 0 : _b.length) && (React__default.createElement(ArrowBottomIconStyled, { rotated: expandedOption === option }))),
                expandedOption === option && (React__default.createElement(Box, { display: "flex", flexDirection: "column" }, option.children.map(function (_a) {
                    var childLabel = _a.label, childHref = _a.href, o = __rest(_a, ["label", "href"]);
                    return (React__default.createElement(ZigMenuItem, __assign({}, o, (childHref &&
                        (routerContext
                            ? {
                                component: Link,
                                to: childHref,
                            }
                            : { component: "a", href: childHref })), { onClick: onClick(o.onClick), key: o.id }), childLabel));
                })))));
        }
        return null;
    };
    return (React__default.createElement(React__default.Fragment, null,
        option.separator && React__default.createElement(StyledDivider, { sx: __assign(__assign({}, option.sx), { padding: 0 }) }),
        renderOption()));
};
var MenuContent = function (_a) {
    var _b = _a.id, id = _b === void 0 ? "" : _b, options = _a.options, expandedOption = _a.expandedOption, setExpandedOption = _a.setExpandedOption, onClick = _a.onClick, setOpen = _a.setOpen;
    var handleListKeyDown = function (event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        }
        else if (event.key === "Escape") {
            setOpen(false);
        }
    };
    return (React__default.createElement(MenuList, { id: id && id, "aria-labelledby": "composition-button", onKeyDown: handleListKeyDown }, options.map(function (option, i) {
        if (expandedOption && options.indexOf(expandedOption) < i)
            return null;
        var key = (option && "label" in option && typeof option.label === "string" && option.label) ||
            option.id ||
            Math.random().toString();
        return (React__default.createElement(MenuOption, { option: option, index: i, key: key, onClick: onClick, expandedOption: expandedOption, setExpandedOption: setExpandedOption, setOpen: setOpen }));
    })));
};

export { MenuContent, MenuOption };
